import apic from './apic';
import micro from './apic/micro';
import dojoTheme from './dojo-theme';
export const fullTheme = {
    theme: Object.assign({}, dojoTheme.theme, apic.theme),
    variants: {
        default: dojoTheme.variants.default,
        aipc: apic.variants.aipc,
        cic1: apic.variants.cic1,
        ltccip1: apic.variants.ltccip1
    }
};
export const microTheme = {
    theme: Object.assign({}, dojoTheme.theme, micro.theme),
    variants: {
        default: dojoTheme.variants.default,
        msurv1: micro.variants.msurv1
    }
};
export default fullTheme;
